import React from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card className='mb-3 index-card' cypressid={`under_construction_cypressid`}>
          <Card.Body className='text-center'>
            <FontAwesomeIcon
              className='font-icon mb-2'
              icon={faExclamation}
              style={{ color: "#147995", fontSize: "500%" }}
            />
            <br />
            <span style={{ color: "#5fa7be" }}>Oops! Something went wrong!</span>
          </Card.Body>
        </Card>
      );
    } else return this.props.children;
  }
}
